import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Feature } from '../../classes/auth/feature.class';
import { Functionality } from '../../classes/auth/functionality';
import { Role } from '../../classes/auth/role.class';
import { CodaltComponent } from '../../codalt.component';
import { AuthorisationService } from '../../services/auth/authorisation.service';

@Component({
    selector: 'app-rights-management',
    standalone: false,
    templateUrl: './rights-management.component.html',
    styleUrl: './rights-management.component.scss',
})
export class RightsManagementComponent extends CodaltComponent implements OnInit {
    disabled = false;

    roles: Role[];
    functionalities: Functionality[];
    features: Feature[];

    search: string;
    highlightedRoleKeys: string[] = [];
    showOnlyHighlightedRoles = false;

    private title = inject(Title);

    constructor(private authorisationService: AuthorisationService) {
        super();
    }

    ngOnInit() {
        this.title.setTitle('Rechtenmatrix' + environment.titleAppend);

        this.subscriptions.add(
            this.authorisationService.getRoles().subscribe(roles => {
                roles.sort((a, b) => {
                    if (a.is_unique !== b.is_unique) {
                        return a.is_unique ? -1 : 1;
                    }

                    return a.name.localeCompare(b.name);
                });

                this.roles = roles;
            })
        );
        this.subscriptions.add(
            this.authorisationService.getFunctionalities().subscribe(functionalities => {
                this.functionalities = functionalities;
            })
        );
        this.subscriptions.add(
            this.authorisationService.getFeatures().subscribe(features => {
                this.features = features;
            })
        );
    }

    checkFunctionality(event: InputEvent, functionality: Functionality, role: Role) {
        if ((event.target as HTMLInputElement).checked) {
            this.subscriptions.add(
                this.authorisationService.addFunctionalityToRole(role.key, functionality.key).subscribe()
            );
        } else {
            this.subscriptions.add(
                this.authorisationService.removeFunctionalityFromRole(role.key, functionality.key).subscribe()
            );
        }
    }

    checkFeature(event: InputEvent, functionality: Functionality, feature: Feature) {
        if ((event.target as HTMLInputElement).checked) {
            this.subscriptions.add(
                this.authorisationService.addFeatureToFunctionality(functionality.key, feature.key).subscribe()
            );
        } else {
            this.subscriptions.add(
                this.authorisationService.removeFeatureFromFunctionality(functionality.key, feature.key).subscribe()
            );
        }
    }

    toggleRoleHighlight(event: MouseEvent, role: Role) {
        event.preventDefault();

        if (this.highlightedRoleKeys.includes(role.key)) {
            this.highlightedRoleKeys = this.highlightedRoleKeys.filter(key => key !== role.key);
            return;
        }

        this.highlightedRoleKeys = [...this.highlightedRoleKeys, role.key];
    }

    isRoleHighlighted(role: Role) {
        return this.highlightedRoleKeys.includes(role.key);
    }

    shouldShowRole(role: Role) {
        return !this.showOnlyHighlightedRoles || this.isRoleHighlighted(role);
    }

    toggleHighlightedRolesVisibility() {
        if (!this.highlightedRoleKeys.length) {
            return;
        }

        this.showOnlyHighlightedRoles = !this.showOnlyHighlightedRoles;
    }
}
